
    import Vue from "vue";
    import {Component, Prop} from "vue-property-decorator";
    import {VueInject} from "@/VueIntegration/VueInjectable";
    import {Slideshow} from "@/slideshow";
    import {IAppearance} from "@/Core/TutorialVariables";

    @Component({})
    export default class VueButton extends Vue {
        @VueInject("Slideshow") readonly slideshow: Slideshow;

        @Prop({default: false}) disabled: boolean;
        appearance: IAppearance;

        created() {
            this.appearance = this.slideshow.appearance;
        }

        clicked() {
            this.$emit('click');
        }
    }
